/** Отдельно от версии телефонов: скрытие № не меняет выбранные страны. */
export const BASE_ROW_NUMBER_LAYOUT_VERSION = 1;

/** Один раз убрать дублирующий № из старого вида, сохранив последующий выбор. */
export function migrateBaseRowNumberView<T extends Record<string, unknown>>(view: T): T {
  if (view.baseRowNumberLayoutVersion === BASE_ROW_NUMBER_LAYOUT_VERSION) return view;
  const result: Record<string, unknown> = { ...view, baseRowNumberLayoutVersion: BASE_ROW_NUMBER_LAYOUT_VERSION };
  if (Array.isArray(view.columns)) result.columns = view.columns.filter(key => key !== 'rowNumber');
  return result as T;
}
